import { CheckIcon, Flex, FlexProps, Text } from '@joinrepublic/dls-ui-kit';

export interface IRegionSwitcherItemProps extends FlexProps {
  title: string;
  isActive?: boolean;
  icon?: JSX.Element;
}

export const RegionSwitcherItem = ({
  title,
  isActive,
  icon,
  ...props
}: IRegionSwitcherItemProps) => {
  return (
    <Flex
      color={isActive ? 'grey.600' : undefined}
      cursor={isActive ? 'default' : 'pointer'}
      alignContent="space-between"
      alignItems="center"
      _hover={{ bg: isActive ? undefined : 'grey.50' }}
      {...props}
    >
      {icon}
      <Text flexGrow="10" color="inherit" ml="2">
        {title}
      </Text>
      {isActive ? (
        <CheckIcon ml="auto" key="CheckMarkIcon" color="grey.400" boxSize="6" />
      ) : null}
    </Flex>
  );
};
